import script from "./RewardSettingsQueryAll.vue?vue&type=script&lang=js"
export * from "./RewardSettingsQueryAll.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__